export const RAITINGS_DEFAULT = {
    ['A']: 'ATP - Suitable for all audiences',
    ['B']: 'For ages 12 and up',
    ['+13']: 'Suitable for ages 13 and up',
    ['+16']: 'Suitable for over 16 years',
    ['+18']: 'C - Suitable for people over 18 years old',
    ['NR']: 'Unrated'
}